import MainPage from "./pages/main";
import AboutPage from "./pages/about";
import MyServicePage from "./pages/service";
import MyBlogPage from "./pages/blog";
import NotFound from "./pages/404"
import "./App.css";

import {
	BrowserRouter as Router,
	Routes,
	Route,
	Navigate
} from "react-router-dom";


function App() {
  return (
    <div className="App">
    	<Router>
	      	<Routes>		      		
	      		<Route path="/" element={<MainPage />} /> 

	      		<Route exact path="/about/" element={<AboutPage />} /> 

	      		<Route exact path="/service/" element={<MyServicePage />} /> 

	      		<Route exact path="/blog/" element={<MyBlogPage />} /> 

	      		<Route exact path="/404/" element={<NotFound />} /> 

	      		<Route path="*" element={<Navigate replace to="/404/" />} />
    		
	      	</Routes>

	      </Router>

    </div>
  );
}

export default App;
